export default class Tag {
    id:string = "";
    text:string = "";
    name:string = "";
    positiveTotal:number = 0;
    negativeTotal:number = 0;
}



// WEBPACK FOOTER //
// ./src/objects/Tag.ts